import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Accountings/Document";
import AccountTafsilTransfer from "./Accountings/AccountTafsilTransfer";
import AccountMoeinTransfer from "./Accountings/AccountMoeinTransfer";
import { NavLink } from 'react-router-dom';

export default class TransctionsReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            caller: props.Caller,
            isPopup: this.isNull(props.IsPopup) ? false : props.IsPopup,
            level: this.isNull(props.Level) ? 1 : props.Level,
            data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            configName: 'transactions_report',
        }
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        this.state.id = props.Id;
        this.state.level = this.isNull(props.Level) ? 1 : props.Level;
        this.refreshData();
    }
    refreshData() {
        var parentId = this.getDefaultGuid();
        var childId = this.getDefaultGuid();
        var id = this.getCurrentFormId();

        if (this.state.isPopup === false) {
            if (this.state.level === 2) {
                parentId = this.getCurrentFormId();
                id = this.getCurrentFormId2();
            }
            if (this.state.level === 3) {
                parentId = this.getCurrentFormId();
                childId = this.getCurrentFormId2();
                id = this.getCurrentFormId3();
            }
        }

        this.httpPost("api/v1/report/transactions", {
            id,
            parentId,
            childId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    articleTafsilTransfer() {
        var documentItemsId = this.state.selectedIds;
        if (this.isEmpty(documentItemsId)) {
            this.showErorrMessage("انتخاب حداقل یک آرتیکل جهت انتقال الزامی می باشد");
            return;
        }
        this.showComponents({ component: <AccountTafsilTransfer Caller={this} DocumentItemsId={documentItemsId} OrganizationId={this.state.data.global.company.id} /> });
    }
    articleMoeinTransfer() {
        var documentItemsId = this.state.selectedIds;
        if (this.isEmpty(documentItemsId)) {
            this.showErorrMessage("انتخاب حداقل یک آرتیکل جهت انتقال الزامی می باشد");
            return;
        }
        this.showComponents({
            component: <AccountMoeinTransfer Caller={this} DocumentItemsId={documentItemsId} />
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Document Caller={this} Id={id} IsTemplate={false} /> });
    }
    showTafsil() {
        if (this.state.level === 2) return true;
        return false;
    }
    getColumns() {
        var t = [];
        t.push({ field: "date", headerName: "تاریخ" });
        t.push({ field: "description", flex: 2, headerName: "شرح سند" });
        t.push({ field: "number2", headerName: "شماره عطف", cellDataType: 'number' });
        t.push({
            field: "number", headerName: "شماره سند", cellDataType: 'number', cellRenderer: (props) => {
                return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.documentId)} title="مشاهده و ویرایش">
                    {props.data.number}
                </a>
            }
        });
        t.push({
            field: "moeinTitle", flex: 2, headerName: "معین", cellRenderer: (props) => {
                return <a className="text-primary txt-bold hand" href={"/report/transactions/" + props.data.moeinAccountId + (props.data.tafsilAccountId == this.getDefaultGuid() ? "" : "/" + props.data.tafsilAccountId) + "/"}>
                    {props.data.moeinCode} - {props.data.moeinTitle}
                </a>
            }
        });
        if (this.showTafsil()) {
            t.push({
                field: "tafsilTitle", flex: 2, headerName: "تفصیل", cellRenderer: (props) => {
                    if (props.data.tafsilCode <= 0) return null;
                    return <a className="text-primary txt-bold hand" href={"/report/transactions/" + props.data.moeinAccountId + (props.data.tafsilAccountId == null ? "" : "/" + props.data.tafsilAccountId) + "/"}>
                        {props.data.tafsilCode} - {props.data.tafsilTitle}
                    </a>
                }
            });
        }
        t.push({ field: "bed", headerName: "گردش بدهکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
        t.push({ field: "bes", headerName: "گردش بستانکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
        t.push({ field: "balance", headerName: "مانده", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.balance) } });
        return t;
    }
    renderForm() {
        return <div className="container">
            <div className="col-sm-10">
                {this.state.data.account.type === 4 && <NavLink className="text-primary txt-bold hand" to={"/report/explore3u/" + this.state.data.account.id + "/"}>نمایش گردش معین های مرتبط با {this.state.data.account.title}</NavLink>}
            </div>
            <div className="col-sm-2 text-left">
                <ul className="nk-block-tools g-3">
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.articleMoeinTransfer()}><span>انتقال معین آرتیکلها</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.articleTafsilTransfer()}><span>انتقال تفصیل آرتیکلها</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('مرور حسابها')}><span>چاپ</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('مرور حسابها')}><span>PDF</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('مرور حسابها')}><span>اکسل</span></a>
                    </li>
                </ul>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns(),
                pagination: false
            })}
        </div>
    }
    setAgGridSelectedRow(e) {
        var t = [];
        e.forEach(ee => t.push(ee.id));
        this.state.selectedIds = t;
    }
    renderPopupForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" id="DocumentModalViewerContent">
                        <div className="panel panel-info center-block" style={{ "max-width": " none" }}>
                            <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                                <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">گردش حساب</h4>
                            </div>
                            <div className="modal-body">
                                {this.renderForm()}
                            </div>
                            <div className="modal-footer">
                                <a className="btn btn-warning" onClick={e => this.closeMe()} > برگشت</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                !this.state.isPopup && <Header data={this.state.data} />,
                this.getGlobalContainer(),
                this.state.isPopup ? this.renderPopupForm() : this.renderForm(),
                this.renderPopupComponent(),
                !this.state.isPopup && <Footer />
            ];

        return contents;
    }
}